var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1786 10.5308L12.845 15.78C12.3687 16.2486 11.5433 15.9206 11.5433 15.2488V12.2493H7.22564C6.80339 12.2493 6.4637 11.915 6.4637 11.4994V8.49992C6.4637 8.08436 6.80339 7.75004 7.22564 7.75004H11.5433V4.75054C11.5433 4.0819 12.3656 3.75071 12.845 4.21938L18.1786 9.46851C18.4738 9.76221 18.4738 10.2371 18.1786 10.5308ZM8.49554 15.6237V14.3739C8.49554 14.1677 8.3241 13.999 8.11457 13.999H5.44777C4.88584 13.999 4.43185 13.5522 4.43185 12.9992V7.00017C4.43185 6.44713 4.88584 6.00033 5.44777 6.00033H8.11457C8.3241 6.00033 8.49554 5.83161 8.49554 5.62539V4.3756C8.49554 4.16939 8.3241 4.00066 8.11457 4.00066H5.44777C3.76515 4.00066 2.4 5.34419 2.4 7.00017V12.9992C2.4 14.6551 3.76515 15.9987 5.44777 15.9987H8.11457C8.3241 15.9987 8.49554 15.83 8.49554 15.6237Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.41519999721f8869710f49571d0ad638.svg";
export { ForwardRef as ReactComponent };